import { render, staticRenderFns } from "./evolucoes-related-block.vue?vue&type=template&id=aa65ae1c"
import script from "./evolucoes-related-block.vue?vue&type=script&lang=js"
export * from "./evolucoes-related-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports